"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const ModalFooter_1 = __importDefault(require("./ModalFooter"));
exports.default = ModalFooter_1.default;
